export const NS = {
  ADMIN: 'admin',
  ALTER: 'alter',
  BLOG: 'blog',
  CATEG: 'category',
  CELLAR: 'cellar',
  CHECKOUT: 'checkout',
  COMMON: 'common',
  COUNTRIES: 'countries',
  CUSTOMIZATION: 'customization',
  PRODUCT: 'product',
};
